'use client';

import { __awaiter, __generator } from '../_virtual/_tslib.js';
import React__default, { useState, useEffect } from 'react';
import { Dialog, ListStyle } from './ForceLogOut.css.js';
import Popup from '../Popup/index.js';
import Button from '../Button/index.js';
import { ELanguage } from '../Utils/constants.js';
import { checkRefreshToken } from './services.js';
import translations from './translations.js';
import { isMobile, encrypt, detectEncryptAccessToken } from '../Utils/helpers.js';
import BottomSheet from '../BottomSheet/index.js';
import { Paragraph } from '../Typography/components/Variant.js';
import { setCookie } from '../Utils/cookie.js';
import { WS_TOKEN, JS_TOKEN, JS_ALL_TOKEN, USER_COOKIE, WS_COOKIE } from '../LoginModal/constants.js';

var ForceLogOut = function (props) {
    var langCode = props.langCode, mode = props.mode, user = props.user, pageName = props.pageName;
    var _a = useState(false), openPopup = _a[0], setOpenPopup = _a[1];
    var baseSecureURL = "https://".concat(mode === 'production' ? "" : "".concat(mode, "-"), "secure.vietnamworks.com");
    var isResponsive = isMobile();
    var t = function (text) {
        if (langCode === ELanguage.EN) {
            return text;
        }
        else {
            return translations[text] || text;
        }
    };
    var stopBodyScrolling = function () {
        if (typeof window !== undefined) {
            document.body.style.overflow = 'hidden';
        }
    };
    var resumeBodyScrolling = function () {
        if (typeof window !== undefined) {
            document.body.style.overflow = 'initial';
        }
    };
    var checkExpireToken = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, accessToken, _b, refreshToken, TOKEN_LENGTH, encodeAccessToken, encodeRefreshToken, isExpireSessionWS;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!user) return [3 /*break*/, 2];
                    _a = user.accessToken, accessToken = _a === void 0 ? '' : _a, _b = user.refreshToken, refreshToken = _b === void 0 ? '' : _b;
                    TOKEN_LENGTH = 86;
                    encodeAccessToken = accessToken.length === TOKEN_LENGTH ? encrypt(accessToken) : accessToken;
                    encodeRefreshToken = refreshToken.length === TOKEN_LENGTH ? encrypt(refreshToken) : refreshToken;
                    if (!encodeAccessToken && !encodeRefreshToken) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, checkRefreshToken(encodeAccessToken, encodeRefreshToken, langCode, baseSecureURL)];
                case 1:
                    isExpireSessionWS = _c.sent();
                    if (isExpireSessionWS) {
                        setOpenPopup(true);
                        setCookie(WS_TOKEN, '');
                        setCookie(JS_TOKEN, '');
                        setCookie(JS_ALL_TOKEN, '');
                        setCookie(USER_COOKIE, '');
                        setCookie(WS_COOKIE, '');
                        stopBodyScrolling();
                    }
                    _c.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var handleLogin = function () {
        var loginEvent = new CustomEvent('LOGIN_POPUP', {
            detail: {
                langCode: langCode,
                isNeedReload: false,
                onLoggedIn: function () {
                    setOpenPopup(false);
                }
            }
        });
        window.dispatchEvent(loginEvent);
    };
    var handleLogOut = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            fetch('/jobseekers/ajax.php?action=track-logout', { headers: { 'Content-Type': 'application/json' } })
                .then(function (response) { return response.json(); })
                .then(function (data) {
                var _a;
                if (data.status === 'success') {
                    var logOutUrl = "".concat(baseSecureURL, "/logout/").concat(langCode, "?client_id=3").concat((user === null || user === void 0 ? void 0 : user.userId) ? '&accessToken=' + detectEncryptAccessToken((_a = user === null || user === void 0 ? void 0 : user.accessToken) !== null && _a !== void 0 ? _a : '') : '');
                    location.assign("".concat(logOutUrl, "&as=1"));
                }
                resumeBodyScrolling();
            })
                .catch(function (err) {
                console.log(err);
            });
            return [2 /*return*/];
        });
    }); };
    useEffect(function () {
        if (window) {
            // authtoken will direct login, it's from mobile link, not check expire token
            var queryString = window.location.search;
            var urlParams = new URLSearchParams(queryString);
            if (!urlParams.get('authtoken') && !urlParams.get('authToken') && pageName !== 'wowCv') {
                checkExpireToken();
            }
        }
    }, [user]);
    var renderFooter = function () { return (React__default.createElement(Dialog.Footer, { isMobile: isResponsive },
        React__default.createElement(Button, { style: { width: '100%' }, onClick: handleLogOut }, t('Stay logged out')),
        React__default.createElement(Button, { style: { width: '100%' }, onClick: handleLogin, type: 'primary' }, t('Login to continue')))); };
    var renderBody = function () { return (React__default.createElement(Dialog.Container, null,
        React__default.createElement(Dialog.Body, null,
            React__default.createElement("div", { style: { padding: 16 } },
                React__default.createElement("img", { width: 200, height: 110, src: "".concat(props.baseImgUrl, "/images/force-logout.jpg") })),
            React__default.createElement(Paragraph, { name: 'title', size: 'large' }, t('Your session expired for one of two reasons:')),
            React__default.createElement(ListStyle, { style: { marginTop: 8 } },
                React__default.createElement("li", null,
                    React__default.createElement(Paragraph, { name: 'paragraph', size: 'medium' }, t("You've been active for a long time.")))),
            React__default.createElement(ListStyle, null,
                React__default.createElement("li", null,
                    React__default.createElement(Paragraph, { name: 'paragraph', size: 'medium' }, t("You've signed out on another device.")))),
            React__default.createElement(Paragraph, { name: 'paragraph', size: 'medium', style: { marginTop: 8 } }, t('Ready to log back in?'))))); };
    return !isResponsive ? (React__default.createElement(Popup, { isShow: openPopup, onClose: function () { }, lang: langCode, custom: {
            footer: renderFooter(),
            header: React__default.createElement(React__default.Fragment, null)
        }, styleOption: {
            size: 'xs'
        } }, renderBody())) : (React__default.createElement(BottomSheet, { onClose: function () { }, options: { isCloseOnClickBackdrop: false, isHaveCloseIcon: false }, isOpen: openPopup, header: React__default.createElement(React__default.Fragment, null), footer: renderFooter() }, renderBody()));
};

export { ForceLogOut as default };
//# sourceMappingURL=index.js.map
